import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import MyLocationIcon from "@mui/icons-material/MyLocation";

import { useTranslation } from "react-i18next";
import AppContext from "../../../../Contexts/AppContext";
import {
  recenterOnUser,
  requestOrExplainGeolocation,
} from "../../../../../services/MapCore/MapService";

export const CenterUserControl = ({ map }) => {
  const { t } = useTranslation("main");
  const { mapInstanceRef, geoStatus } = useContext(AppContext);
  const geoReady = geoStatus === "ready" || geoStatus === "updating";
  const loading = geoStatus === "requesting";

  const centerUser = async () => {
    if (geoReady) {
      recenterOnUser(mapInstanceRef.current);
      return;
    }
    await requestOrExplainGeolocation(mapInstanceRef.current);
  };

  return (
    <Tooltip title={t("center_user")}>
      <IconButton
        onClick={centerUser}
        className="mapButton"
        disabled={loading}
        aria-busy={loading ? "true" : "false"}
        aria-label={loading ? t("locating") || "Locating..." : t("center_user")}
      >
        {loading ? <CircularProgress size={20} /> : <MyLocationIcon />}
      </IconButton>
    </Tooltip>
  );
};
